import React, { useState } from 'react';
import api from '../api/client';

interface Props {
  selectedCprcodes: string[];
  onClearSelection: () => void;
  onBulkEditComplete: () => void;
}

export default function BulkEditBar({ selectedCprcodes, onClearSelection, onBulkEditComplete }: Props) {
  const [field, setField] = useState('');
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (selectedCprcodes.length === 0) return null;

  const editableFields = [
    { key: 'category', label: 'Category' },
    { key: 'brand', label: 'Brand' },
    { key: 'is_selling', label: 'Selling Status' },
  ];

  const handleApply = async () => {
    if (!field || !value) return;
    setLoading(true);
    try {
      const updates: Record<string, unknown> = {};
      if (field === 'is_selling') {
        updates[field] = value === 'true';
      } else {
        updates[field] = value;
      }
      await api.bulkEdit(selectedCprcodes, updates);
      setError(null);
      onBulkEditComplete();
      onClearSelection();
      setField('');
      setValue('');
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Unknown error';
      setError(`Bulk edit failed: ${message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      padding: '8px 16px',
      background: '#eff6ff',
      borderBottom: '1px solid #bfdbfe',
      fontSize: 13,
    }}>
      <span style={{ fontWeight: 600 }}>{selectedCprcodes.length} selected</span>
      <select value={field} onChange={(e) => { setField(e.target.value); setError(null); }}
        style={{ padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: 4, fontSize: 13 }}>
        <option value="">Select field...</option>
        {editableFields.map((f) => (
          <option key={f.key} value={f.key}>{f.label}</option>
        ))}
      </select>
      {field === 'is_selling' ? (
        <select value={value} onChange={(e) => { setValue(e.target.value); setError(null); }}
          style={{ padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: 4, fontSize: 13 }}>
          <option value="">Select...</option>
          <option value="true">Selling</option>
          <option value="false">Not Selling</option>
        </select>
      ) : (
        <input value={value} onChange={(e) => { setValue(e.target.value); setError(null); }} placeholder="New value..."
          style={{ padding: '4px 8px', border: '1px solid #d1d5db', borderRadius: 4, fontSize: 13, width: 200 }} />
      )}
      <button onClick={handleApply} disabled={loading || !field || !value}
        style={{ padding: '4px 12px', background: '#2563eb', color: 'white', border: 'none', borderRadius: 4, fontSize: 13, cursor: 'pointer', opacity: (loading || !field || !value) ? 0.5 : 1 }}>
        {loading ? 'Applying...' : 'Apply'}
      </button>
      {error && <span style={{ color: '#ef4444', fontSize: 13 }}>{error}</span>}
      <button onClick={onClearSelection}
        style={{ padding: '4px 12px', background: 'transparent', border: '1px solid #d1d5db', borderRadius: 4, fontSize: 13, cursor: 'pointer' }}>
        Clear
      </button>
    </div>
  );
}
